import config from "../config/app.conf.json";

export default email => ({
  url: config.api.resend_email,
  method: "POST",
  data: {
    emails: [email]
  }
});
